import type { BrandRuntimeConfig, BrandId } from './types';
import { DEFAULT_BRAND_ID, normalizeBrandId } from './types';

export const BRAND_CONFIGS: Record<BrandId, BrandRuntimeConfig> = {
  'trade-proof': {
    id: 'trade-proof',
    displayName: 'Trade-Proof',
    frontDoor: 'marketing',
    landingUrl: '/',
    authUi: {
      portalLabel: 'Secure sign-in',
    },
  },
  'warrior-trading': {
    id: 'warrior-trading',
    displayName: 'Warrior Trading',
    frontDoor: 'login',
    landingUrl: 'https://warrior-trading.trade-proof.com',
    authUi: {
      portalLabel: 'Client portal',
    },
  },
};

export function getBrandRuntimeConfig(brandId?: string | null): BrandRuntimeConfig {
  const normalizedBrandId = normalizeBrandId(brandId);
  return BRAND_CONFIGS[normalizedBrandId ?? DEFAULT_BRAND_ID];
}
